import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kw-search-nav',
  templateUrl: './search-nav.component.html',
  styleUrls: ['./search-nav.component.scss']
})
export class SearchNavComponent implements OnInit {
  filter = true;
  constructor() { }

  ngOnInit(): void {
  }
  toggleFilter(value){
    console.log("WTF");
  }
  onSearch(value){
    console.log("WTF");
  }

}
